import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('export-button', (editor, opts = {}) => {
  let c = opts;
  const default_types = {
    exportButton: 'export-button',
  };
  const default_labels = {
    exportButton: 'ExportButton',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelExportButtonCategory: 'Advanced',
    },
    ...opts,
  };
  for (let name in options) {
    if (!(name in c)) c[name] = options[name];
  }
  loadComponents(editor, opts);
});
